import {
  QuotaCardAdvanceActivateCode,
} from '../models/card-quota/quota-card-advance.model';
import {
  downloadReportExcel,
  formatReportInputDate,
} from './report-excel-export.util';

export interface ActivateCodesExcelMeta {
  advanceId: number;
  advanceName: string;
  siteName?: string | null;
  clientName?: string | null;
  subscriptionName?: string | null;
  vehicleTypeName?: string | null;
  cardTypeName?: string | null;
  qty?: number | null;
  startDate?: string | null;
  endDate?: string | null;
}

function toDisplayDate(value: string | null | undefined): string {
  if (!value) return '-';
  const day = value.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return formatReportInputDate(day);
  }
  return value;
}

function toDisplayDateTime(value: string | null | undefined): string {
  if (!value) return '-';
  const day = value.slice(0, 10);
  const time = value.length >= 16 ? value.slice(11, 16) : '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return time ? `${formatReportInputDate(day)} ${time}` : formatReportInputDate(day);
  }
  return value;
}

function safeFilePart(value: string): string {
  return (value || 'advance').replace(/[^\w\-ก-๙]+/g, '_').slice(0, 60);
}

/** Export รหัส Activate แบบจัดรูปแบบ (หัวข้อ amber / แถวสลับ / meta) */
export async function downloadActivateCodesExcel(
  codes: QuotaCardAdvanceActivateCode[],
  meta: ActivateCodesExcelMeta,
): Promise<void> {
  const used = codes.filter((c) => c.isUsed).length;
  const unused = codes.length - used;
  const start = meta.startDate?.slice(0, 10) || '';
  const end = meta.endDate?.slice(0, 10) || start || new Date().toISOString().slice(0, 10);

  const rows = codes.map((r, index) => ({
    ลำดับ: index + 1,
    'รหัส Activate': r.code,
    'วันเริ่มบัตร': toDisplayDate(r.startDate),
    'วันหมดอายุบัตร': toDisplayDate(r.endDate),
    สถานะ: r.isUsed ? 'ใช้แล้ว' : 'ยังไม่ใช้',
    'วันหมดอายุรหัส': toDisplayDateTime(r.activateExpireAt),
    'วันที่ Activate': toDisplayDateTime(r.activateDate),
  }));

  const fileName = `ActivateCodes_${safeFilePart(meta.advanceName || String(meta.advanceId))}_${meta.advanceId}.xlsx`;

  await downloadReportExcel(rows, {
    fileName,
    sheetName: 'รหัส Activate',
    reportTitle: 'รหัส Activate — บัตรล่วงหน้า',
    siteName: meta.siteName?.trim() || meta.clientName?.trim() || '-',
    startDate: start || end,
    endDate: end || start,
    extraLines: [
      `เลขที่ใบคำขอ: #${meta.advanceId} · ${meta.advanceName || '-'}`,
      `ร้าน: ${meta.clientName?.trim() || '-'}`,
      `Subscription: ${meta.subscriptionName?.trim() || '-'}`,
      `ประเภทบัตร / รถ: ${meta.cardTypeName?.trim() || '-'} / ${meta.vehicleTypeName?.trim() || '-'}`,
      `จำนวนรหัส: ${meta.qty ?? codes.length} · ยังไม่ใช้ ${unused} · ใช้แล้ว ${used}`,
    ],
  });
}
